/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/sendAppDownloadLinkMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a SendAppDownloadLink. */
export class SendAppDownloadLink {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a SendAppDownloadLink.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Send App Download link to the email provided by the current user.
   * @summary Send App Download link to given email.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendAppDownloadLinkByEmail(options?: Models.SendAppDownloadLinkSendAppDownloadLinkByEmailOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  sendAppDownloadLinkByEmail(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendAppDownloadLinkByEmail(options: Models.SendAppDownloadLinkSendAppDownloadLinkByEmailOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendAppDownloadLinkByEmail(options?: Models.SendAppDownloadLinkSendAppDownloadLinkByEmailOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      sendAppDownloadLinkByEmailOperationSpec,
      callback);
  }

  /**
   * Send App Download link to the phone number provided by the current user.
   * @summary Send App Download link to given phone.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendAppDownloadLinkByPhone(options?: Models.SendAppDownloadLinkSendAppDownloadLinkByPhoneOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  sendAppDownloadLinkByPhone(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendAppDownloadLinkByPhone(options: Models.SendAppDownloadLinkSendAppDownloadLinkByPhoneOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendAppDownloadLinkByPhone(options?: Models.SendAppDownloadLinkSendAppDownloadLinkByPhoneOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      sendAppDownloadLinkByPhoneOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const sendAppDownloadLinkByEmailOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/downloads/email",
  queryParameters: [
    Parameters.email
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendAppDownloadLinkByPhoneOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/downloads/sms",
  queryParameters: [
    Parameters.countryCode,
    Parameters.phoneNumber
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
